import React from 'react'

import HoverTooltip from '../../../../../components/HoverTooltip'

import Section from '../../../../../components/Section'
import { CurrencyList } from '../types'
import PurchaseTable from './PurchaseBaseInfoTab/Table/PurchaseTable'
import { Purchase } from '../../types'

type Props = {
    theme: string
    purchase: Purchase
    isActive: boolean
    currencyList: CurrencyList[]
    dataReloadToken: number
    purchaseYear: number | null
}

const PurchaseBaseInfoTab: React.FC<Props> = (props) => {
    return (
        <Section title="Информация о закупке">
            <div className="flex flex-col w-full gap-x-5 ">
                <PurchaseTable
                    theme={props.theme}
                    purchaseGuid={props.purchase.guid}
                    purchaseRegNumber={String(
                        props.purchase.registration_number
                    )}
                    isActive={props.isActive}
                    currencyList={props.currencyList}
                    // contractPrice={props.purchase.price}
                    dataReloadToken={props.dataReloadToken}
                    purchaseVersion={props.purchase.version}
                    purchaseYear={props.purchaseYear}
                    purchaseStage={props.purchase.purchase_stage}
                />
            </div>
        </Section>
    )
}

export default PurchaseBaseInfoTab
